{
  "name": "g3w-client",
  "version": "4.0.7",
  "description": "Gis3W WebGIS Client",
  "main": "index.js",
  "scripts": {
    "preinstall": "",
    "build": "gulp version && gulp build",
    "dev": "gulp dev",
    "docker": "docker compose --env-file ../g3w-suite-docker/.env --file ../g3w-suite-docker/docker-compose-dev.yml --project-name g3w-suite-docker --project-directory ../g3w-suite-docker",
    "docker:pull": "npm run docker pull",
    "docker:up": "npm run docker up -- -d",
    "docker:down": "npm run docker down",
    "docker:config": "npm run docker config",
    "docker:logs": "npm run docker logs",
    "test": "",
    "preversion": "npm run test",
    "version": "npm run build && git add -A",
    "postversion": "git push && git push --tags"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/g3w-suite/g3w-client.git"
  },
  "author": "",
  "license": "MPL-2.0",
  "homepage": "https://github.com/g3w-suite/g3w-client.git",
  "dependencies": {
    "@fortawesome/fontawesome-free": "^5.15.4",
    "@mapbox/shp-write": "^0.4.3",
    "@ungap/with-resolvers": "^0.1.0",
    "bootstrap": "^3.3.7",
    "datatables.net-dt": "^1.10.16",
    "eonasdan-bootstrap-datetimepicker": "^4.17.49",
    "invokers-polyfill": "^0.5.5",
    "ismobilejs": "^1.1.1",
    "jquery": "^2.2.1",
    "jsts": "^2.11.3",
    "jszip": "^3.10.1",
    "localforage": "^1.10.0",
    "lodash.clonedeep": "^4.5.0",
    "moment": "^2.19.1",
    "ol": "^10.4.0",
    "proj4": "^2.14.0",
    "quill": "^2.0.0-dev.4",
    "scriptjs": "^2.5.9",
    "select2": "^4.0.4",
    "shpjs": "^6.1.0",
    "util-deprecate": "^1.0.2",
    "vue": "2.7.16",
    "vue-color": "^2.8.1",
    "vue-cookie": "^1.1.4",
    "vue-cookie-law": "^1.13.3",
    "vue2-teleport": "^1.1.4",
    "wolfy87-eventemitter": "^5.2.9"
  },
  "devDependencies": {
    "del": "^2.2.2",
    "esbuild": "^0.24.0",
    "esbuild-vue": "^1.2.2",
    "gulp": "^4.0.2",
    "gulp-flatten": "^0.2.0",
    "gulp-prompt": "^1.2.0",
    "gulp-rename": "^1.2.2",
    "jshint": "^2.9.1",
    "jshint-stylish": "^2.1.0",
    "vue-template-compiler": "2.7.16"
  },
  "engines": {
    "node": ">=22.9.0",
    "npm": ">=10.8.3"
  }
}
